export default __webpack_public_path__ + "static/media/zw.0cb3e43f.jpg";